/* global window */

import get from 'lodash/get';

import { m3u8Url, highestResolutionMp4Url } from './utils';

export default class Video {
  constructor(id, settings, attributes) {
    this.id = id;
    this.settings = settings;
    this.attributes = attributes;
  }

  get thumbnail() {
    const thumbnail = this.croppedPreviewImage;

    if (!thumbnail) {
      return thumbnail;
    }

    // In some cases, the thumbnail isn't cropped to the size we
    // want for the playlist.  So we do that by hand.
    const thumbnailUrl = new window.URL(thumbnail);

    // Resize first, then crop.  We append these operations
    // in case earlier operations are needed for the preview
    // proper.
    thumbnailUrl.searchParams.append('resize', '240:*');
    thumbnailUrl.searchParams.append('crop', '240:135');

    return thumbnailUrl.toString();
  }

  get croppedPreviewImage() {
    return get(this.attributes, 'cropped_preview_image', '');
  }

  get m3u8Url() {
    return m3u8Url(get(this.attributes, 'transcodings', []));
  }

  get mp4Url() {
    return highestResolutionMp4Url(get(this.attributes, 'transcodings', []));
  }

  get videoSource() {
    return get(this.attributes, 'source.title', '');
  }

  get videoId() {
    return get(this.attributes, 'id', '');
  }

  /**
   * @return {string} The title of the asset.
   */
  get title() {
    return get(this.attributes, 'title', '');
  }

  /**
   * @return {string} A description of the video asset.
   */
  get description() {
    return get(this.attributes, 'description', '');
  }

  /**
   * return an SRC useable by the player
   */
  get src() {
    const src = [
      {
        src: this.m3u8Url,
        videoId: this.videoId,
        type: 'application/x-mpegURL',
      },
    ];

    // only push in the mp4 URL if it's available
    if (this.mp4Url) {
      src.push({
        src: this.mp4Url,
        videoId: this.videoId,
        type: 'video/mp4',
      });
    }

    return src;
  }
}
